// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* IBBranding Colors */
  --ibPrimaryDark: #122048;
  --ibPrimaryLight: #42b9ea;
  --ibAccent: #f04b24;
  --ibLightGray: #f5f5f5;

  /*
    IB UI Common
      NOTE: Link CSS defined in index.html & theme.js
  */

  --linkColor: #19a6e0;
  --totalsBadge: var(--ibAccent);

  /* IB Event Criticality:  NOTE: Values repeated in colors.js */
  --eventCriticalityBackgroundCritical: #f44336;
  --eventCriticalityBackgroundMajor: #ed7d31;
  --eventCriticalityBackgroundMinor: #d79d80;
  --eventCriticalityBackgroundWarning: #ffc600;
  --eventCriticalityBackgroundInfo: #088fa3;
  --eventCriticalityBackgroundOK: #3fa142;
  --eventCriticalityForegroundCritical: #fff;
  --eventCriticalityForegroundMajor: #fff;
  --eventCriticalityForegroundMinor: #fff;
  --eventCriticalityForegroundWarning: #fff;
  --eventCriticalityForegroundInfo: #fff;
  --eventCriticalityForegroundOK: #fff;

  /* IB Ticket Type Colors */
  --ticketTypeChange: #ffc600;
  --ticketTypeIncident: #ed7d31;
  --ticketTypeProblem: #f44336;
  --ticketTypeService: #d79d80;
  --ticketTypeProject: #088fa3;

  /* IB Compliant / Non-Compliant */
  --ibCompliant: var(--eventCriticalityBackgroundOK);
  --ibNonCompliant: #ed3620;

  /* IB Success / Fail */
  --ibSuccess: var(--ibCompliant);
  --ibFailed: var(--ibNonCompliant);

  /* IB Risk */
  --ibHealthOffTrack: var(--eventCriticalityBackgroundCritical);
  --ibHealthAtRisk: var(--eventCriticalityBackgroundMajor);
  --ibHealthOnTrack: var(--eventCriticalityBackgroundOK);
  --ibHealthNeeded: var(--eventCriticalityBackgroundWarning);

  /* IB Completion Status */
  --ibCompletionOverdue: var(--eventCriticalityBackgroundCritical);
  --ibCompletionNotStarted: var(--eventCriticalityBackgroundMajor);
  --ibCompletionInProgress: var(--eventCriticalityBackgroundInfo);
  --ibCompletionComplete: var(--eventCriticalityBackgroundOK);

  /* IB Free / Used (Disk Space) */
  --ibFreeSpace: var(--ibCompliant);
  --ibUsedSpace: var(--ibNonCompliant);

  /* IB Background Colors */
  --ibBackgroundOverdue: #ed3620;
  --darkBlue: #006bf2;
  --error: #ff4d4f;
  --warning: #ffc8c5;
  --redHighlight: #fff1f0;
  --darkGray: #778088;
  --textGray: #676a6c;
  --lightGray: #f3f3f3;
  --deepGray: #666;
  --teal: #23c6c8;
  --blueBackground: #2f4050;

  /* Brand Colors */
  --red: #ed3620;
  --blue: #3498db;
  --turquoise: #41b4a6;
  --orange: #ff8f00;
  --green: #3fa142;
  --purple: #9209ae;
  --violet: #3e4eb8;
  --navy: #0048c7;

  /* Gradients */
  --turquoise-gradient-dark: #3aaea0;
  --turquoise-gradient-light: #72e0d1;
  --turquoise-gradient: linear-gradient(90deg, var(--turquoise-gradient-dark), var(--turquoise-gradient-light));
  --blue-gradient-dark: #309cd9;
  --blue-gradient-light: #5ecbee;
  --blue-gradient: linear-gradient(90deg, var(--blue-gradient-dark) 0%, var(--blue-gradient-light) 100%);

  /* Antd Colors */
  --antd-blue: #1890ff;
  --antd-lightBlue: #40a9ff;
  --antd-borderGray: #d9d9d9;
  --antd: #f0f2f5;

  /* Neutral Colors */
  --white: #fff;
  --mist: #fafafa;
  --fog: #f5f5f5;
  --typhoon: #eee;
  --ash: #ddd;
  --silver: #ccc;
  --gray: #999;
  --dim: #555;
  --dark: #333;
  --black: #000;
  --inactive: #bbb;

  /* Opacity gradient colors */
  --black0_8: rgb(0 0 0 / 85%);
  --black0_6: rgb(0 0 0 / 65%);
  --black0_4: rgb(0 0 0 / 45%);
  --black0_2: rgb(0 0 0 / 25%);
  --white0_8: rgb(255 255 255 / 85%);
  --white0_6: rgb(255 255 255 / 65%);
  --white0_4: rgb(255 255 255 / 45%);
  --white0_2: rgb(255 255 255 / 25%);

  /* Work Order Status Colors */
  --unassigned: var(--gray);
  --assigned: var(--orange);
  --inProgress: var(--navy);
  --completed: var(--green);
  --closed: var(--ash);
  --positive: var(--green);
  --negative: var(--red);
  --highlight: rgb(0 0 0 / 5%);
  --link: var(--linkColor);
  --boxshadow: var(--black0_2);
  --lowOpacityBoxShadow: rgb(0 0 0 / 20%);

  /* Criticality colors */
  --criticality-compliant: #1890ff;
  --criticality-positive: #3fa142;
  --criticality-critical: #970000;
  --criticality-high: #f44336;
  --criticality-medium: #fc6c1a;
  --criticality-low: #ffc600;
  --criticality-info: #5b5b5b;

  /* Health status colors - taken from antd Badge component */
  --health-needed: #d9d9d9;
  --health-off-track: #ff4d4f;
  --health-at-risk: #faad14;
  --health-on-track: #3fa142;
  --info-widget-background-light: #dceaf7;
}
`, "",{"version":3,"sources":["webpack://./client/styles/colors.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;;EAEtB;;;GAGC;;EAED,oBAAoB;EACpB,8BAA8B;;EAE9B,8DAA8D;EAC9D,6CAA6C;EAC7C,0CAA0C;EAC1C,0CAA0C;EAC1C,4CAA4C;EAC5C,yCAAyC;EACzC,uCAAuC;EACvC,0CAA0C;EAC1C,uCAAuC;EACvC,uCAAuC;EACvC,yCAAyC;EACzC,sCAAsC;EACtC,oCAAoC;;EAEpC,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,iCAAiC;EACjC,kDAAkD;EAClD,yBAAyB;;EAEzB,sBAAsB;EACtB,+BAA+B;EAC/B,iCAAiC;;EAEjC,YAAY;EACZ,6DAA6D;EAC7D,wDAAwD;EACxD,sDAAsD;EACtD,0DAA0D;;EAE1D,yBAAyB;EACzB,gEAAgE;EAChE,gEAAgE;EAChE,+DAA+D;EAC/D,2DAA2D;;EAE3D,gCAAgC;EAChC,iCAAiC;EACjC,oCAAoC;;EAEpC,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;;EAEzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;;EAEf,cAAc;EACd,kCAAkC;EAClC,mCAAmC;EACnC,6GAA6G;EAC7G,6BAA6B;EAC7B,8BAA8B;EAC9B,sGAAsG;;EAEtG,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;;EAEf,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;EACf,WAAW;EACX,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;;EAEhB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;;EAElC,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;EACpB,wBAAwB;EACxB,sBAAsB;EACtB,4BAA4B;EAC5B,wBAAwB;EACxB,4BAA4B;EAC5B,uCAAuC;;EAEvC,uBAAuB;EACvB,gCAAgC;EAChC,+BAA+B;EAC/B,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;;EAE3B,2DAA2D;EAC3D,wBAAwB;EACxB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,uCAAuC;AACzC","sourcesContent":[":root {\n  /* IBBranding Colors */\n  --ibPrimaryDark: #122048;\n  --ibPrimaryLight: #42b9ea;\n  --ibAccent: #f04b24;\n  --ibLightGray: #f5f5f5;\n\n  /*\n    IB UI Common\n      NOTE: Link CSS defined in index.html & theme.js\n  */\n\n  --linkColor: #19a6e0;\n  --totalsBadge: var(--ibAccent);\n\n  /* IB Event Criticality:  NOTE: Values repeated in colors.js */\n  --eventCriticalityBackgroundCritical: #f44336;\n  --eventCriticalityBackgroundMajor: #ed7d31;\n  --eventCriticalityBackgroundMinor: #d79d80;\n  --eventCriticalityBackgroundWarning: #ffc600;\n  --eventCriticalityBackgroundInfo: #088fa3;\n  --eventCriticalityBackgroundOK: #3fa142;\n  --eventCriticalityForegroundCritical: #fff;\n  --eventCriticalityForegroundMajor: #fff;\n  --eventCriticalityForegroundMinor: #fff;\n  --eventCriticalityForegroundWarning: #fff;\n  --eventCriticalityForegroundInfo: #fff;\n  --eventCriticalityForegroundOK: #fff;\n\n  /* IB Ticket Type Colors */\n  --ticketTypeChange: #ffc600;\n  --ticketTypeIncident: #ed7d31;\n  --ticketTypeProblem: #f44336;\n  --ticketTypeService: #d79d80;\n  --ticketTypeProject: #088fa3;\n\n  /* IB Compliant / Non-Compliant */\n  --ibCompliant: var(--eventCriticalityBackgroundOK);\n  --ibNonCompliant: #ed3620;\n\n  /* IB Success / Fail */\n  --ibSuccess: var(--ibCompliant);\n  --ibFailed: var(--ibNonCompliant);\n\n  /* IB Risk */\n  --ibHealthOffTrack: var(--eventCriticalityBackgroundCritical);\n  --ibHealthAtRisk: var(--eventCriticalityBackgroundMajor);\n  --ibHealthOnTrack: var(--eventCriticalityBackgroundOK);\n  --ibHealthNeeded: var(--eventCriticalityBackgroundWarning);\n\n  /* IB Completion Status */\n  --ibCompletionOverdue: var(--eventCriticalityBackgroundCritical);\n  --ibCompletionNotStarted: var(--eventCriticalityBackgroundMajor);\n  --ibCompletionInProgress: var(--eventCriticalityBackgroundInfo);\n  --ibCompletionComplete: var(--eventCriticalityBackgroundOK);\n\n  /* IB Free / Used (Disk Space) */\n  --ibFreeSpace: var(--ibCompliant);\n  --ibUsedSpace: var(--ibNonCompliant);\n\n  /* IB Background Colors */\n  --ibBackgroundOverdue: #ed3620;\n  --darkBlue: #006bf2;\n  --error: #ff4d4f;\n  --warning: #ffc8c5;\n  --redHighlight: #fff1f0;\n  --darkGray: #778088;\n  --textGray: #676a6c;\n  --lightGray: #f3f3f3;\n  --deepGray: #666;\n  --teal: #23c6c8;\n  --blueBackground: #2f4050;\n\n  /* Brand Colors */\n  --red: #ed3620;\n  --blue: #3498db;\n  --turquoise: #41b4a6;\n  --orange: #ff8f00;\n  --green: #3fa142;\n  --purple: #9209ae;\n  --violet: #3e4eb8;\n  --navy: #0048c7;\n\n  /* Gradients */\n  --turquoise-gradient-dark: #3aaea0;\n  --turquoise-gradient-light: #72e0d1;\n  --turquoise-gradient: linear-gradient(90deg, var(--turquoise-gradient-dark), var(--turquoise-gradient-light));\n  --blue-gradient-dark: #309cd9;\n  --blue-gradient-light: #5ecbee;\n  --blue-gradient: linear-gradient(90deg, var(--blue-gradient-dark) 0%, var(--blue-gradient-light) 100%);\n\n  /* Antd Colors */\n  --antd-blue: #1890ff;\n  --antd-lightBlue: #40a9ff;\n  --antd-borderGray: #d9d9d9;\n  --antd: #f0f2f5;\n\n  /* Neutral Colors */\n  --white: #fff;\n  --mist: #fafafa;\n  --fog: #f5f5f5;\n  --typhoon: #eee;\n  --ash: #ddd;\n  --silver: #ccc;\n  --gray: #999;\n  --dim: #555;\n  --dark: #333;\n  --black: #000;\n  --inactive: #bbb;\n\n  /* Opacity gradient colors */\n  --black0_8: rgb(0 0 0 / 85%);\n  --black0_6: rgb(0 0 0 / 65%);\n  --black0_4: rgb(0 0 0 / 45%);\n  --black0_2: rgb(0 0 0 / 25%);\n  --white0_8: rgb(255 255 255 / 85%);\n  --white0_6: rgb(255 255 255 / 65%);\n  --white0_4: rgb(255 255 255 / 45%);\n  --white0_2: rgb(255 255 255 / 25%);\n\n  /* Work Order Status Colors */\n  --unassigned: var(--gray);\n  --assigned: var(--orange);\n  --inProgress: var(--navy);\n  --completed: var(--green);\n  --closed: var(--ash);\n  --positive: var(--green);\n  --negative: var(--red);\n  --highlight: rgb(0 0 0 / 5%);\n  --link: var(--linkColor);\n  --boxshadow: var(--black0_2);\n  --lowOpacityBoxShadow: rgb(0 0 0 / 20%);\n\n  /* Criticality colors */\n  --criticality-compliant: #1890ff;\n  --criticality-positive: #3fa142;\n  --criticality-critical: #970000;\n  --criticality-high: #f44336;\n  --criticality-medium: #fc6c1a;\n  --criticality-low: #ffc600;\n  --criticality-info: #5b5b5b;\n\n  /* Health status colors - taken from antd Badge component */\n  --health-needed: #d9d9d9;\n  --health-off-track: #ff4d4f;\n  --health-at-risk: #faad14;\n  --health-on-track: #3fa142;\n  --info-widget-background-light: #dceaf7;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
